import { PropTypes } from "@l2r-front/l2r-proptypes"

import * as Styled from "./RoadworkDetailsInfo.styled"

export function RoadworkDetailsSkeleton(props) {

    const { className } = props

    return <Styled.RoadworkDetailWrapper className={className}>
        <Styled.RoadworkDetailSkeleton />
    </Styled.RoadworkDetailWrapper>
}

RoadworkDetailsSkeleton.propTypes = {
    className: PropTypes.string,
}